import { render, staticRenderFns } from "./liveAreaStatistics.vue?vue&type=template&id=533239c0"
import script from "./liveAreaStatistics.vue?vue&type=script&lang=js"
export * from "./liveAreaStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports